import type { RouteRecordRaw } from 'vue-router'
import { $t } from '@/locales'

function Layout() {
  return import('@/layouts/index.vue')
}

const routes: RouteRecordRaw = {
  path: '/card_manage',
  component: Layout,
  redirect: '/card_manage/list',
  name: 'CardManage',
  meta: {
    title: $t('route.card_manage.title'),
    icon: 'card_manage',
  },
  children: [
    {
      path: 'list',
      name: 'CardManageList',
      component: () => import('@/views/card_manage/list.vue'),
      meta: {
        title: $t('route.card_manage.list'),
        icon: 'card_manage_list',
      },
    },
    {
      path: 'detail',
      name: 'CardManageDetail',
      component: () => import('@/views/card_manage/list/components/ViewCardDetails/index.vue'),
      meta: {
        title: $t('route.card_manage.detail'),
        menu: false,
      },
    },
    {
      path: 'holder',
      name: 'CardManageHolder',
      component: () => import('@/views/card_manage/holder.vue'),
      meta: {
        title: $t('route.card_manage.holder'),
        icon: 'card_manage_holder',
      },
    },
  ],
}

export default routes
